export default __webpack_public_path__ + "static/giveaway-options-64eb340e537d5723f6c0db45f45479b5.png";